const accordions = (): void => {
  const classes = {
    accordionOpen: 'accordion__item--open',
  };

  const selectors = {
    accordions: '[data-accordions]',
    accordionItem: '[data-accordion-item]',
    accordionItemTitle: '[data-accordion-item-title]',
    accordionItemToggle: '[data-accordion-item-toggle]',
    accordionItemContent: '[data-accordion-item-content]',
    accordionItemContentOpenOnLoad: 'open-on-load',
  };

  const openAccordion = (accordion: HTMLElement): void => {
    const content = accordion.querySelector<HTMLElement>(
      selectors.accordionItemContent
    );
    accordion.classList.add(classes.accordionOpen);
    content.style.maxHeight = content.scrollHeight + 'px';
  };

  const closeAccordion = (accordion: HTMLElement): void => {
    const content = accordion.querySelector<HTMLElement>(
      selectors.accordionItemContent
    );
    accordion.classList.remove(classes.accordionOpen);
    content.style.maxHeight = null;
  };

  const accordionSections = document.querySelectorAll(selectors.accordions);
  accordionSections.forEach((section) => {
    const accordions = section.querySelectorAll<HTMLElement>(
      selectors.accordionItem
    );
    accordions.forEach((accordion) => {
      const title = accordion.querySelector<HTMLElement>(
        selectors.accordionItemTitle
      );
      const content = accordion.querySelector<HTMLElement>(
        selectors.accordionItemContent
      );

      if (content.hasAttribute(selectors.accordionItemContentOpenOnLoad)) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      title.onclick = (): void => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion);
        }
      };
    });

    window.addEventListener('resize', () => {
      accordions.forEach((accordion: HTMLElement) => {
        const content = accordion.querySelector<HTMLElement>(
          selectors.accordionItemContent
        );
        if (content && content.style.maxHeight) {
          openAccordion(accordion);
        }
      });
    });
  });
};

export default accordions;
